export default "https://dakcheck.solease.nl/static/media/money.8a452921.svg";